/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_PromptInputs */



/**
* | output |
* | --- |
* | "Enter a query or filters to search storage." |
*
* @param {Explorer_Search_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_prompt = /** @type {((inputs?: Explorer_Search_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
	return /** @type {LocalizedString} */ ("Enter a query or filters to search storage.")
});